export default __webpack_public_path__ + "static/media/Ahmed Shaikh.c3014873.jpeg";